import React from 'react'
import MonthlyMeetingListEntry from './MonthlyMeetingListEntry';

export default function MonthlyMeetingList({oym,list,dropBreadcrumb,authenticated}) {
    console.log("MM List authenticated "+authenticated);
    let objectList=list.map(meeting => oym.objectRef(meeting));
    objectList.sort(oym.compareOYMObject);
    let montlyMeetings=objectList.map(monthlyMeeting => {
        console.log(monthlyMeeting.name);
        return <MonthlyMeetingListEntry key={monthlyMeeting.name} monthlyMeeting={monthlyMeeting} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} />
    });
    return (
        <>
            {montlyMeetings}
        </>
    )
}
